module.exports = __webpack_public_path__ + "static/media/hero.1f44f537.webp";